import React, { useCallback, useMemo } from 'react';
import { PropTypes } from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import AuthenticatedUserView from 'refactored/ui/views/authenticatedUserView';

import OrderDetailComponent from 'components/orders/OrderDetail/SingleOrderDetail';
import RecurringOrderDetailComponent from 'components/orders/OrderDetail/RecurringOrderDetail';
import ModalCancelOrder from 'components/ModalCancelOrder';

import routes from 'utils/routes';
import { useDispatch, useSelector } from 'react-redux';
import { selectors as uiSelectors } from 'state/ui';
import { actions as ordersActions } from 'state/orders';
import FeasibilityContextProvider from 'hooks/useFeasibility';
import styled from 'styled-components';

const OrderDetailsSection = styled.section`
  /* border: 1px solid red; */
  width: 100%;
`;

const OrderDetail = (props) => <OrderDetailComponent {...props} />;
const RecurringOrderDetail = (props) => (
  <RecurringOrderDetailComponent {...props} />
);

const getTypeOfOrderOpened = (path) =>
  (path.includes('active') && 'active') ||
  (path.includes('previous') && 'previous') ||
  (path.includes('recurring') && 'recurring') ||
  (path.includes('search') && 'search');

const OrderDetails = ({ className, match, history }) => {
  const dispatch = useDispatch();
  const isModalCancelOrderOpened = useSelector(
    uiSelectors.isCancelOrderModalOpened
  );

  const orderType = useMemo(() => getTypeOfOrderOpened(match?.path), [match]);
  const handleBack = useCallback(() => {
    dispatch(ordersActions.closeOrder({ type: orderType }));
  }, [dispatch, orderType]);

  return (
    <FeasibilityContextProvider>
      <AuthenticatedUserView className={className} handleBack={handleBack}>
        <OrderDetailsSection
          role="main"
          className="main"
          data-testid="order-details-page"
        >
          <ConnectedRouter history={history}>
            <Switch>
              <Route
                path={`${routes.orders.active}/:orderId`}
                component={OrderDetail}
              />
              <Route
                path={`${routes.orders.previous}/:orderId`}
                component={OrderDetail}
              />
              <Route
                path={`${routes.orders.search}/:orderId`}
                component={OrderDetail}
              />
              <Route
                path={`${routes.orders.recurring}/:orderId`}
                component={RecurringOrderDetail}
              />
            </Switch>
          </ConnectedRouter>
        </OrderDetailsSection>
        {isModalCancelOrderOpened && <ModalCancelOrder />}
      </AuthenticatedUserView>
    </FeasibilityContextProvider>
  );
};

OrderDetails.propTypes = {
  className: PropTypes.string,
  history: PropTypes.object,
  match: PropTypes.object,
};

OrderDetails.defaultProps = {
  history: {},
  match: {},
};

export default OrderDetails;
